import { Component, inject, output } from '@angular/core';
import { Section } from '../legal-text.component';
import { ConfigurationService } from '@core/services';

@Component({
  selector: 'app-legal-notice',
  templateUrl: './legal-notice.component.html',
  standalone: true,
})
export class LegalNoticeComponent {
  configurationService = inject(ConfigurationService);
  displaySectionEmitter = output<Section>();

  get CUSTOMER_NAME() {
    return this.configurationService.configuration.clientName;
  }
}
